export default __webpack_public_path__ + "6f040e5e02769406207e3200c3a3b264.svg";